// Validación/máscara de documentos LATAM con @zeluizr/palta (frontend UX).
// La validación de seguridad real vive en LatamIdValidator (Ruby).
// Forzar CJS: el entry ESM usa optional chaining que Webpacker 4/babel
// no transpila dentro de node_modules.
const palta = require('@zeluizr/palta/dist/index.cjs')

const PERSON_DOCS = {
  cl: { mod: palta.cl && palta.cl.rut, label: 'RUT' },
  ar: { mod: palta.ar && palta.ar.dni, label: 'DNI' },
  br: { mod: palta.br && palta.br.cpf, label: 'CPF' },
  co: { mod: palta.co && palta.co.cc, label: 'Cédula' },
  pe: { mod: palta.pe && palta.pe.dni, label: 'DNI' },
  uy: { mod: palta.uy && palta.uy.ci, label: 'Cédula' },
  mx: { mod: palta.mx && palta.mx.curp, label: 'CURP' },
  ve: { mod: palta.ve && palta.ve.ci, label: 'CI' },
  ec: { mod: palta.ec && palta.ec.ci, label: 'CI' },
  bo: { mod: palta.bo && palta.bo.ci, label: 'CI' },
  py: { mod: palta.py && palta.py.ci, label: 'CI' },
  do: { mod: palta.do_ && palta.do_.cedula, label: 'Cédula' },
  cr: { mod: palta.cr && palta.cr.cedula, label: 'Cédula' },
  pa: { mod: palta.pa && palta.pa.cedula, label: 'Cédula' },
  gt: { mod: palta.gt && palta.gt.dpi, label: 'DPI' },
  hn: { mod: palta.hn && palta.hn.dni, label: 'DNI' },
  sv: { mod: palta.sv && palta.sv.dui, label: 'DUI' },
  ni: { mod: palta.ni && palta.ni.cedula, label: 'Cédula' },
  cu: { mod: palta.cu && palta.cu.ni, label: 'Carnet' },
  pr: { mod: palta.pr && palta.pr.ssn, label: 'SSN' },
  ht: { mod: palta.ht && palta.ht.cin, label: 'CIN' },
  jm: { mod: palta.jm && palta.jm.nin, label: 'NIN' },
  tt: { mod: palta.tt && palta.tt.nis, label: 'NIS' }
}

const TAX_DOCS = {
  cl: { mod: palta.cl && palta.cl.rut, label: 'RUT' },
  ar: { mod: palta.ar && palta.ar.cuit, label: 'CUIT/CUIL' },
  br: { mod: palta.br && palta.br.cnpj, label: 'CNPJ' },
  co: { mod: palta.co && palta.co.nit, label: 'NIT' },
  pe: { mod: palta.pe && palta.pe.ruc, label: 'RUC' },
  uy: { mod: palta.uy && palta.uy.rut, label: 'RUT' },
  mx: { mod: palta.mx && palta.mx.rfc, label: 'RFC' },
  ve: { mod: palta.ve && palta.ve.rif, label: 'RIF' },
  ec: { mod: palta.ec && palta.ec.ruc, label: 'RUC' },
  bo: { mod: palta.bo && palta.bo.nit, label: 'NIT' },
  py: { mod: palta.py && palta.py.ruc, label: 'RUC' },
  do: { mod: palta.do_ && palta.do_.rnc, label: 'RNC' },
  cr: { mod: palta.cr && (palta.cr.juridica || palta.cr.cedula), label: 'Cédula jurídica' },
  pa: { mod: palta.pa && palta.pa.ruc, label: 'RUC' },
  gt: { mod: palta.gt && palta.gt.nit, label: 'NIT' },
  hn: { mod: palta.hn && palta.hn.rtn, label: 'RTN' },
  sv: { mod: palta.sv && palta.sv.nit, label: 'NIT' },
  ni: { mod: palta.ni && palta.ni.ruc, label: 'RUC' },
  cu: { mod: palta.cu && palta.cu.reeup, label: 'REEUP' },
  pr: { mod: palta.pr && palta.pr.ein, label: 'EIN' },
  ht: { mod: palta.ht && palta.ht.nif, label: 'NIF' },
  jm: { mod: palta.jm && palta.jm.trn, label: 'TRN' },
  tt: { mod: palta.tt && palta.tt.tin, label: 'TIN' }
}

function selectedIso(selectEl) {
  if (!selectEl) return ''
  var option = selectEl.options[selectEl.selectedIndex]
  if (!option) return ''
  return (option.getAttribute('data-iso') || '').toLowerCase()
}

function docsFor(mode) {
  return mode === 'tax' ? TAX_DOCS : PERSON_DOCS
}

function defaultValid(value) {
  var cleaned = String(value || '').replace(/\s+/g, '')
  if (cleaned.length < 5 || cleaned.length > 20) return false
  return /^[A-Za-z0-9\-./]+$/.test(cleaned)
}

var ERROR_INPUT_MAP = {
  'user-dni-error': 'user_dni',
  'user-email-error': 'user_email',
  'user-phone-error': 'user_phone',
  'business-dni-error': 'business_dni_input'
}

// Mismo estilo que Simple Form / Bootstrap: texto rojo chico (.invalid-feedback)
function showError(boxId, message, asHtml) {
  var box = document.getElementById(boxId)
  if (!box) return
  var input = document.getElementById(ERROR_INPUT_MAP[boxId] || '')
  if (!message) {
    box.classList.remove('d-block')
    box.textContent = ''
    if (input) input.classList.remove('is-invalid')
    return
  }
  if (asHtml) {
    box.innerHTML = message
  } else {
    box.textContent = message
  }
  box.classList.add('d-block')
  if (input) input.classList.add('is-invalid')
}

function updateLabel(labelEl, baseText, docLabel) {
  if (!labelEl) return
  var base = (baseText || labelEl.getAttribute('data-base-label') || labelEl.textContent || '').split('(')[0].trim()
  labelEl.setAttribute('data-base-label', base)
  labelEl.textContent = docLabel ? (base + ' (' + docLabel + ')') : base
}

function bindDocumentField(config) {
  var countrySelect = document.getElementById(config.countrySelectId)
  var dniInput = document.getElementById(config.dniInputId)
  if (!countrySelect || !dniInput) return

  var mode = (countrySelect.getAttribute('data-latam-mode') || config.mode || 'person')
  var labelEl = document.querySelector(config.labelSelector)
  var errorBoxId = config.errorBoxId
  var invalidMsg = config.invalidMessage || 'El documento no es válido para el país seleccionado.'

  function currentDoc() {
    var iso = selectedIso(countrySelect)
    return docsFor(mode)[iso] || null
  }

  function applyCountry() {
    var doc = currentDoc()
    updateLabel(labelEl, null, doc && doc.label)
    if (doc && doc.mod && doc.mod.mask) {
      dniInput.setAttribute('placeholder', String(doc.mod.mask))
    } else {
      dniInput.removeAttribute('placeholder')
    }
    if (typeof config.onCountryChange === 'function') {
      config.onCountryChange(selectedIso(countrySelect))
    }
    validateCurrent(false)
  }

  function validateCurrent(showWhenEmpty) {
    var value = dniInput.value
    if (!value) {
      if (showWhenEmpty) showError(errorBoxId, 'Debe ingresar el documento.')
      else showError(errorBoxId, '')
      return !showWhenEmpty
    }
    var doc = currentDoc()
    var ok
    if (doc && doc.mod && typeof doc.mod.validate === 'function') {
      ok = doc.mod.validate(value)
    } else {
      ok = defaultValid(value)
    }
    showError(errorBoxId, ok ? '' : invalidMsg)
    return ok
  }

  function formatCurrent() {
    var doc = currentDoc()
    if (!doc || !doc.mod || typeof doc.mod.format !== 'function') return
    var formatted = doc.mod.format(dniInput.value)
    if (formatted) dniInput.value = formatted
  }

  countrySelect.addEventListener('change', applyCountry)
  if (window.jQuery) {
    window.jQuery(countrySelect).on('changed.bs.select', applyCountry)
  }

  dniInput.addEventListener('blur', function () {
    formatCurrent()
    validateCurrent(false)
  })
  dniInput.addEventListener('input', function () {
    showError(errorBoxId, '')
  })

  var form = dniInput.closest('form')
  if (form) {
    form.addEventListener('submit', function (e) {
      var ok = validateCurrent(true)
      if (!ok) {
        e.preventDefault()
        e.stopPropagation()
        dniInput.focus()
      }
      if (typeof config.onSubmit === 'function' && !config.onSubmit()) {
        e.preventDefault()
        e.stopPropagation()
      }
    })
  }

  applyCountry()
}

// Alineado con User::EMAIL_FORMAT: exige TLD de al menos 2 letras
// (rechaza a@c.c; acepta nombre@dominio.com).
function isValidEmail(value) {
  var email = String(value || '').trim()
  if (!email) return false
  return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/.test(email)
}

// Alineado con User.cencosud_corporate_email?: lista + subdominios.
function restrictedSignupDomains(emailInput) {
  var raw = emailInput && emailInput.getAttribute('data-internal-email-domains')
  if (!raw) return []
  return raw.split(',').map(function (item) { return item.trim().toLowerCase() }).filter(Boolean)
}

function isCencosudCorporateEmail(value, emailInput) {
  var email = String(value || '').trim()
  var at = email.lastIndexOf('@')
  if (at < 0) return false
  var domain = email.slice(at + 1).toLowerCase()
  var domains = restrictedSignupDomains(emailInput)
  for (var i = 0; i < domains.length; i++) {
    var listed = domains[i]
    if (domain === listed || domain.slice(-(listed.length + 1)) === '.' + listed) return true
  }
  return false
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function cencosudEmailErrorHtml(emailInput) {
  var message = emailInput.getAttribute('data-cencosud-email-error') ||
    'Este correo no se puede usar para inscribir una empresa. Revisa el dato o, si tienes acceso interno, ingresa como Colaborador.'
  var url = emailInput.getAttribute('data-collaborator-login-url')
  var label = emailInput.getAttribute('data-collaborator-login-label') || 'Ingresa como Colaborador'
  if (!url) return escapeHtml(message)
  return escapeHtml(message) + ' <a href="' + escapeHtml(url) + '" class="alert-link">' + escapeHtml(label) + '</a>'
}

function bindEmailField() {
  var emailInput = document.getElementById('user_email')
  if (!emailInput) return function () { return true }

  function validateEmail(forceShow) {
    var value = emailInput.value
    if (!value) {
      if (forceShow) showError('user-email-error', 'Debe ingresar un email.')
      else showError('user-email-error', '')
      return !forceShow
    }
    if (isCencosudCorporateEmail(value, emailInput)) {
      showError('user-email-error', cencosudEmailErrorHtml(emailInput), true)
      return false
    }
    var ok = isValidEmail(value)
    showError('user-email-error', ok ? '' : 'Ingrese un email válido (ej: nombre@dominio.com).')
    return ok
  }

  emailInput.addEventListener('blur', function () { validateEmail(false) })

  return validateEmail
}

function updatePhoneExample(iti, phoneInput) {
  var exampleEl = document.getElementById('user-phone-example')
  if (!exampleEl) return

  var example = ''
  try {
    if (window.intlTelInputUtils && iti && typeof iti.getSelectedCountryData === 'function') {
      var country = iti.getSelectedCountryData()
      var numberType = window.intlTelInputUtils.numberType.MOBILE
      if (country && country.iso2) {
        example = window.intlTelInputUtils.getExampleNumber(country.iso2, false, numberType) || ''
      }
    }
  } catch (e) { /* utils aún no cargados */ }

  if (!example && phoneInput) {
    example = phoneInput.getAttribute('placeholder') || ''
  }

  exampleEl.textContent = example ? '(ej: ' + example + ')' : ''
}

function initUserRegistration() {
  var phoneInput = document.querySelector('#user_phone')
  var iti = null
  if (phoneInput && window.intlTelInput) {
    iti = window.intlTelInput(phoneInput, {
      preferredCountries: ['cl', 'br', 'pe', 'ar', 'co'],
      utilsScript: '/assets/libphonenumber/utils.js',
      initialCountry: 'cl'
    })
    // Ejemplo junto al label (además del placeholder del input).
    updatePhoneExample(iti, phoneInput)
    phoneInput.addEventListener('countrychange', function () {
      updatePhoneExample(iti, phoneInput)
    })
    // utilsScript carga async: reintentar un par de veces el ejemplo.
    var tries = 0
    var timer = setInterval(function () {
      tries += 1
      updatePhoneExample(iti, phoneInput)
      if ((window.intlTelInputUtils && document.getElementById('user-phone-example').textContent) || tries > 10) {
        clearInterval(timer)
      }
    }, 300)
  }

  var validateEmail = bindEmailField()

  bindDocumentField({
    countrySelectId: 'user_country_id',
    dniInputId: 'user_dni',
    labelSelector: '#user_dni_wrapper > label',
    errorBoxId: 'user-dni-error',
    mode: 'person',
    invalidMessage: 'El documento de identidad no es válido para el país seleccionado.',
    onCountryChange: function (iso) {
      if (iti && iso) {
        try { iti.setCountry(iso) } catch (e) { /* país no soportado por intlTelInput */ }
        updatePhoneExample(iti, phoneInput)
      }
    },
    onSubmit: function () {
      if (!validateEmail(true)) {
        var emailInput = document.getElementById('user_email')
        if (emailInput) emailInput.focus()
        return false
      }
      if (!iti) return true
      if (phoneInput.value && typeof iti.isValidNumber === 'function' && !iti.isValidNumber()) {
        showError('user-phone-error', 'El teléfono no es válido para el país seleccionado.')
        phoneInput.focus()
        return false
      }
      showError('user-phone-error', '')
      // Guardar número en formato internacional si es posible
      if (typeof iti.getNumber === 'function' && phoneInput.value) {
        var full = iti.getNumber()
        if (full) phoneInput.value = full
      }
      return true
    }
  })

  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      showError('user-phone-error', '')
    })
  }
}

function initBusinessRegistration() {
  bindDocumentField({
    countrySelectId: 'business_country_of_origin',
    dniInputId: 'business_dni_input',
    labelSelector: '#business_dni > label',
    errorBoxId: 'business-dni-error',
    mode: 'tax',
    invalidMessage: 'El Nº de identificación tributaria no es válido para el país seleccionado.'
  })
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('user_country_id')) {
    initUserRegistration()
  }
  if (document.getElementById('business_country_of_origin') && document.getElementById('business_dni_input')) {
    initBusinessRegistration()
  }
})
